type Translate = (key: string, params?: Record<string, string | number>) => string;

/** JUB-149: a retention deadline is not a guarantee that cleanup has run. */
export function pendingDeletionMessage(error: unknown, t: Translate, locale: string): string | null {
  const body = (error as { response?: { data?: { error?: { code?: string; retentionUntil?: unknown } } } })
    ?.response?.data?.error;
  if (body?.code !== 'account_pending_deletion') return null;

  const deadline = typeof body.retentionUntil === 'string' ? Date.parse(body.retentionUntil) : NaN;
  if (Number.isFinite(deadline) && deadline > Date.now()) {
    const date = new Intl.DateTimeFormat(locale.split('-')[0] === 'en' ? 'en-GB' : 'ro-RO', {
      day: 'numeric', month: 'long', year: 'numeric',
    }).format(new Date(deadline));
    return t('errors.account_pending_deletion_until', { date });
  }

  return t('errors.account_pending_deletion');
}
